import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useDeleteContentTypesMutation } from '../../../generated/graphql';
import styles from './DeleteContentTypesDialog.module.css';

type DeleteContentTypesDialogProps = {
    onClose: () => void;
    visible: boolean;
    contentId: string;
    ids: string[];
    style?: CSSProperties;
    children?: ReactNode;
};

const DeleteContentTypesDialog = ({ style, visible, contentId, ids, onClose }: DeleteContentTypesDialogProps) => {
    const [deleteContentTypes, result] = useDeleteContentTypesMutation();
    const [validationError, setValidationError] = useState('');

    const handleSubmit = async () => {
        if (!contentId || ids.length === 0) {
            setValidationError('No content types were selected.');
            return;
        }

        setValidationError('');
        try {
            await deleteContentTypes({ variables: { id: contentId, ids } });
            onClose();
        } catch (error) {
            setValidationError(error instanceof Error ? error.message : 'The content type could not be deleted.');
        }
    };

    return (
        <DialogBase
            title={ids.length === 1 ? 'Delete Content Type' : 'Delete Content Types'}
            type="YesNo"
            isLoading={result.loading}
            visible={visible}
            onClose={onClose}
            onYesClick={handleSubmit}
            validationError={validationError}
            className={styles.DeleteContentTypesDialog}
            style={style}
        >
            <p style={{ color: 'var(--text-secondary)' }}>
                {ids.length === 1
                    ? 'Are you sure you want to delete this content type?'
                    : `Are you sure you want to delete these ${ids.length} content types?`}
            </p>
        </DialogBase>
    );
};

export default DeleteContentTypesDialog;
